import { render } from "./StudySchemasView.vue?vue&type=template&id=8f9bf55a&scoped=true"
import script from "./StudySchemasView.vue?vue&type=script&lang=js"
export * from "./StudySchemasView.vue?vue&type=script&lang=js"

import "./StudySchemasView.vue?vue&type=style&index=0&id=8f9bf55a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8f9bf55a"]])

export default __exports__